import React from 'react';

// Enhanced VoxSmyth Icon Library
// "Literary Tech with Whisper of Magic" - Complete alignment with design brief
const VoxSmythIcons = {
  // ====== CORE BRAND ICONS ======
  VoxSmythSigil: ({ size = 24, color = '#D7B377', animated = false }) => (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
      {/* Outer mystical ring */}
      <circle cx="16" cy="16" r="14" stroke={color} strokeWidth="1.5" fill="none" opacity="0.6"/>
      {/* Compass points with literary elements */}
      <path d="M16 4L18 14L16 16L14 14L16 4Z" fill={color} opacity="0.9"/>
      <path d="M28 16L18 18L16 16L18 14L28 16Z" fill="#2C3A4C" opacity="0.8"/>
      <path d="M16 28L14 18L16 16L18 18L16 28Z" fill={color} opacity="0.9"/>
      <path d="M4 16L14 14L16 16L14 18L4 16Z" fill="#2C3A4C" opacity="0.8"/>
      {/* Central voice orb */}
      <circle cx="16" cy="16" r="3" fill={color}/>
      {/* Decorative corner flourishes */}
      <path d="M6 8L8 10M26 8L24 10M6 24L8 22M26 24L24 22" stroke={color} strokeWidth="1" opacity="0.5"/>
      {animated && (
        <circle cx="16" cy="16" r="12" stroke={color} strokeWidth="0.5" opacity="0.3">
          <animate attributeName="r" values="12;14;12" dur="3s" repeatCount="indefinite"/>
          <animate attributeName="opacity" values="0.3;0.1;0.3" dur="3s" repeatCount="indefinite"/>
        </circle>
      )}
    </svg>
  ),

  // ====== NAVIGATION ICONS ======
  Dashboard: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      {/* Ancient scroll layout */}
      <rect x="3" y="3" width="8" height="8" rx="2" fill={color} fillOpacity="0.7" stroke="#2C3A4C" strokeWidth="0.5"/>
      <rect x="13" y="3" width="8" height="5" rx="2" fill={color} fillOpacity="0.5" stroke="#2C3A4C" strokeWidth="0.5"/>
      <rect x="3" y="13" width="8" height="8" rx="2" fill={color} fillOpacity="0.6" stroke="#2C3A4C" strokeWidth="0.5"/>
      <rect x="13" y="10" width="8" height="11" rx="2" fill={color} fillOpacity="0.8" stroke="#2C3A4C" strokeWidth="0.5"/>
      {/* Decorative dots */}
      <circle cx="7" cy="7" r="1" fill="#2C3A4C" fillOpacity="0.4"/>
      <circle cx="17" cy="6" r="0.5" fill="#2C3A4C" fillOpacity="0.4"/>
      <circle cx="7" cy="17" r="1" fill="#2C3A4C" fillOpacity="0.4"/>
      <circle cx="17" cy="15" r="0.5" fill="#2C3A4C" fillOpacity="0.4"/>
      {/* Mystical connecting lines */}
      <path d="M11 7L13 6M11 17L13 15" stroke={color} strokeWidth="0.5" opacity="0.3"/>
    </svg>
  ),

  Home: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      {/* Mystical dwelling foundation */}
      <path d="M12 3L20 9V21H15V15H9V21H4V9L12 3Z" fill={color} fillOpacity="0.8" stroke="#2C3A4C" strokeWidth="0.5"/>
      {/* Sacred hearth */}
      <rect x="9" y="15" width="6" height="6" fill="transparent" stroke="#2C3A4C" strokeWidth="0.5" opacity="0.6"/>
      {/* Window of wisdom */}
      <rect x="6" y="11" width="3" height="3" fill="#2C3A4C" fillOpacity="0.4" rx="0.5"/>
      <rect x="15" y="11" width="3" height="3" fill="#2C3A4C" fillOpacity="0.4" rx="0.5"/>
      {/* Mystical rooftop elements */}
      <path d="M12 3L11 4L13 4L12 3Z" fill="#2C3A4C" fillOpacity="0.6"/>
      {/* Floating essence dots */}
      <circle cx="12" cy="1.5" r="0.5" fill={color} opacity="0.4"/>
      <circle cx="21" cy="8" r="0.5" fill={color} opacity="0.3"/>
      <circle cx="3" cy="8" r="0.5" fill={color} opacity="0.3"/>
    </svg>
  ),

  Library: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      {/* Library shelves with mystical atmosphere */}
      <rect x="2" y="4" width="20" height="2" fill="#2C3A4C" opacity="0.8"/>
      <rect x="2" y="11" width="20" height="2" fill="#2C3A4C" opacity="0.8"/>
      <rect x="2" y="18" width="20" height="2" fill="#2C3A4C" opacity="0.8"/>
      
      {/* Ancient tomes */}
      <rect x="4" y="6" width="2.5" height="5" fill={color} opacity="0.9"/>
      <rect x="7" y="6" width="1.5" height="5" fill="#2C3A4C" opacity="0.7"/>
      <rect x="9" y="6" width="3" height="5" fill={color} opacity="0.8"/>
      <rect x="13" y="6" width="2" height="5" fill="#2C3A4C" opacity="0.6"/>
      <rect x="16" y="6" width="2.5" height="5" fill={color} opacity="0.9"/>
      <rect x="19" y="6" width="1.5" height="5" fill="#2C3A4C" opacity="0.8"/>
      
      {/* Middle shelf books */}
      <rect x="3" y="13" width="3" height="5" fill="#2C3A4C" opacity="0.8"/>
      <rect x="7" y="13" width="1.5" height="5" fill={color} opacity="0.7"/>
      <rect x="9" y="13" width="2.5" height="5" fill="#2C3A4C" opacity="0.6"/>
      <rect x="12.5" y="13" width="4" height="5" fill={color} opacity="0.9"/>
      <rect x="17" y="13" width="2" height="5" fill="#2C3A4C" opacity="0.7"/>
      <rect x="20" y="13" width="1.5" height="5" fill={color} opacity="0.8"/>
      
      {/* Mystical shimmer */}
      <path d="M2 3L22 3M2 10L22 10M2 17L22 17" stroke={color} strokeWidth="0.5" opacity="0.3"/>
      
      {/* Floating book essence */}
      <circle cx="5" cy="2" r="0.5" fill={color} opacity="0.4"/>
      <circle cx="12" cy="1" r="0.5" fill={color} opacity="0.3"/>
      <circle cx="19" cy="2" r="0.5" fill={color} opacity="0.4"/>
    </svg>
  ),

  VoiceStudio: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      {/* Theater masks with mystical aura */}
      <path d="M8 6C6 6 4 8 4 10C4 14 6 16 8 16C10 16 12 14 12 10C12 8 10 6 8 6Z" 
            fill={color} fillOpacity="0.7" stroke="#2C3A4C" strokeWidth="0.5"/>
      <path d="M16 6C18 6 20 8 20 10C20 14 18 16 16 16C14 16 12 14 12 10C12 8 14 6 16 6Z" 
            fill={color} fillOpacity="0.7" stroke="#2C3A4C" strokeWidth="0.5"/>
      
      {/* Theater mask features */}
      <ellipse cx="6.5" cy="9" rx="0.5" ry="1" fill="#2C3A4C"/>
      <ellipse cx="9.5" cy="9" rx="0.5" ry="1" fill="#2C3A4C"/>
      <path d="M6 12C7 14 9 14 10 12" stroke="#2C3A4C" strokeWidth="1" fill="none"/>
      
      <ellipse cx="14.5" cy="9" rx="0.5" ry="1" fill="#2C3A4C"/>
      <ellipse cx="17.5" cy="9" rx="0.5" ry="1" fill="#2C3A4C"/>
      <path d="M14 12C15 10 17 10 18 12" stroke="#2C3A4C" strokeWidth="1" fill="none"/>
      
      {/* Mystical connecting ribbons */}
      <path d="M12 4C12 2 12 2 12 2M12 18C12 20 12 20 12 20" stroke={color} strokeWidth="1" opacity="0.5"/>
      
      {/* Sound waves emanating */}
      <circle cx="12" cy="10" r="14" stroke={color} strokeWidth="0.3" opacity="0.2" fill="none"/>
      <circle cx="12" cy="10" r="18" stroke={color} strokeWidth="0.2" opacity="0.1" fill="none"/>
    </svg>
  ),

  Earnings: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      {/* Ancient treasure scroll */}
      <rect x="4" y="6" width="16" height="12" rx="2" fill="#F7F3E9" stroke={color} strokeWidth="1"/>
      <rect x="2" y="6" width="2" height="12" rx="1" fill={color} opacity="0.8"/>
      <rect x="20" y="6" width="2" height="12" rx="1" fill={color} opacity="0.8"/>
      
      {/* Brass coin stack */}
      <ellipse cx="12" cy="14" rx="3" ry="1.5" fill={color} opacity="0.9"/>
      <ellipse cx="12" cy="12.5" rx="3" ry="1.5" fill={color} opacity="0.8"/>
      <ellipse cx="12" cy="11" rx="3" ry="1.5" fill={color} opacity="0.9"/>
      
      {/* Coin details */}
      <circle cx="12" cy="11" r="2" stroke="#2C3A4C" strokeWidth="0.5" opacity="0.6"/>
      <circle cx="12" cy="11" r="1" fill="#2C3A4C" opacity="0.3"/>
      
      {/* Decorative corner flourishes */}
      <path d="M6 8L7 9L6 10M18 8L17 9L18 10M6 16L7 15L6 14M18 16L17 15L18 14" 
            stroke={color} strokeWidth="0.5" opacity="0.4"/>
      
      {/* Mystical shimmer */}
      <path d="M8 9L16 9M8 16L16 16" stroke={color} strokeWidth="0.3" opacity="0.3"/>
    </svg>
  ),

  Settings: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="3" stroke={color} strokeWidth="1.5" fill="none"/>
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" stroke={color} strokeWidth="1.5" fill="none"/>
    </svg>
  ),

  // Password Reset Icons
  Lock: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke={color} strokeWidth="1.5" fill="none"/>
      <path d="M7 11V7a5 5 0 0 1 10 0v4" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="12" cy="16" r="1.5" fill={color}/>
    </svg>
  ),

  Key: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="8" cy="8" r="6" stroke={color} strokeWidth="1.5" fill="none"/>
      <path d="M14.31 10.31L20.5 16.5" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M16.5 14.5L18.5 16.5" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M18.5 14.5L20.5 16.5" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="8" cy="8" r="2" fill={color} fillOpacity="0.3"/>
    </svg>
  ),

  Mail: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <rect x="2" y="4" width="20" height="16" rx="2" stroke={color} strokeWidth="1.5" fill="none"/>
      <path d="M22 6L12 13L2 6" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="18" cy="8" r="1" fill={color} fillOpacity="0.6"/>
    </svg>
  ),

  Loader: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2" strokeLinecap="round" strokeDasharray="60" strokeDashoffset="60">
        <animate attributeName="stroke-dashoffset" values="60;0;60" dur="2s" repeatCount="indefinite"/>
        <animateTransform attributeName="transform" type="rotate" values="0 12 12;360 12 12" dur="2s" repeatCount="indefinite"/>
      </circle>
    </svg>
  ),

  CheckCircle: ({ size = 20, color = '#27AE60' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="1.5" fill="none"/>
      <path d="M9 12L11 14L15 10" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="12" cy="12" r="6" fill={color} fillOpacity="0.1"/>
    </svg>
  ),

  // ====== CREATOR TOOLS ======
  Quill: ({ size = 20, color = '#D7B377', animated = false }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      {/* Mystical quill with enhanced details */}
      <path d="M3 21L8 16C9 15 11 13 13 11L21 3C21.5 2.5 21.5 1.5 21 1C20.5 0.5 19.5 0.5 19 1L11 9C9 11 7 13 6 14L1 19C0.5 19.5 0.5 20.5 1 21C1.5 21.5 2.5 21.5 3 21Z" 
            stroke={color} strokeWidth="1.5" fill={color} fillOpacity="0.6"/>
      
      {/* Quill feather details */}
      <path d="M15 7L16 6M17 5L18 4M19 3L20 2" stroke={color} strokeWidth="0.5" opacity="0.7"/>
      <path d="M13 9L14 8L15 9M16 6L17 5L18 6" stroke={color} strokeWidth="0.3" opacity="0.5"/>
      
      {/* Ink well */}
      <circle cx="5" cy="19" r="2" fill="#2C3A4C" fillOpacity="0.8" stroke={color} strokeWidth="0.5"/>
      <circle cx="5" cy="19" r="1" fill={color} fillOpacity="0.6"/>
      
      {/* Mystical ink drops */}
      <circle cx="7" cy="17" r="0.5" fill={color} opacity={animated ? "0.9" : "0.5"}>
        {animated && (
          <animate attributeName="opacity" values="0.5;0.9;0.5" dur="2s" repeatCount="indefinite"/>
        )}
      </circle>
      <circle cx="9" cy="15" r="0.3" fill={color} opacity="0.4"/>
      
      {/* Enchanted writing trail */}
      <path d="M11 13C13 11 15 9 17 7" stroke={color} strokeWidth="0.5" opacity="0.3" strokeDasharray="1,1"/>
    </svg>
  ),

  VintageMicrophone: ({ size = 20, color = '#D7B377', animated = false }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      {/* Ornate microphone stand */}
      <rect x="11" y="15" width="2" height="7" fill="#2C3A4C" opacity="0.8"/>
      <ellipse cx="12" cy="22" rx="3" ry="1" fill={color} opacity="0.8"/>
      
      {/* Vintage microphone head */}
      <ellipse cx="12" cy="8" rx="4" ry="6" fill={color} fillOpacity="0.7" stroke="#2C3A4C" strokeWidth="1"/>
      <ellipse cx="12" cy="8" rx="2.5" ry="4" fill="none" stroke={color} strokeWidth="0.5" opacity="0.6"/>
      
      {/* Brass details */}
      <circle cx="12" cy="5" r="0.5" fill="#2C3A4C" opacity="0.8"/>
      <circle cx="12" cy="7" r="0.5" fill="#2C3A4C" opacity="0.8"/>
      <circle cx="12" cy="9" r="0.5" fill="#2C3A4C" opacity="0.8"/>
      <circle cx="12" cy="11" r="0.5" fill="#2C3A4C" opacity="0.8"/>
      
      {/* Ornamental bands */}
      <ellipse cx="12" cy="4" rx="4" ry="0.5" fill="#2C3A4C" opacity="0.3"/>
      <ellipse cx="12" cy="12" rx="4" ry="0.5" fill="#2C3A4C" opacity="0.3"/>
      
      {/* Mystical sound emanation */}
      <g style={animated ? { animation: 'sound-pulse 1.5s ease-in-out infinite' } : {}}>
        <path d="M17 6C18 5 19 6 19 8C19 10 18 11 17 10" stroke={color} strokeWidth="1" fill="none" opacity="0.6"/>
        <path d="M18 4C20 3 22 5 22 8C22 11 20 13 18 12" stroke={color} strokeWidth="1" fill="none" opacity="0.4"/>
        <path d="M7 6C6 5 5 6 5 8C5 10 6 11 7 10" stroke={color} strokeWidth="1" fill="none" opacity="0.6"/>
        <path d="M6 4C4 3 2 5 2 8C2 11 4 13 6 12" stroke={color} strokeWidth="1" fill="none" opacity="0.4"/>
      </g>
    </svg>
  ),

  VoiceTraining: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      {/* Calligraphy-style waveform */}
      <path d="M2 12C4 8 6 16 8 12C10 8 12 16 14 12C16 8 18 16 20 12C22 8 22 16 22 12" 
            stroke={color} strokeWidth="2" fill="none" strokeLinecap="round"/>
      <path d="M2 14C4 18 6 10 8 14C10 18 12 10 14 14C16 18 18 10 20 14" 
            stroke={color} strokeWidth="1.5" fill="none" opacity="0.6" strokeLinecap="round"/>
      
      {/* Training progress nodes */}
      <circle cx="6" cy="12" r="1.5" fill={color} opacity="0.9"/>
      <circle cx="12" cy="12" r="1.5" fill={color} opacity="0.8"/>
      <circle cx="18" cy="12" r="1.5" fill={color} opacity="0.7"/>
      
      {/* Mystical recording aura */}
      <circle cx="21" cy="5" r="2.5" fill={color} fillOpacity="0.7" stroke="#2C3A4C" strokeWidth="0.5"/>
      <circle cx="21" cy="5" r="1.5" fill="#2C3A4C" fillOpacity="0.8"/>
      <circle cx="21" cy="5" r="0.5" fill="#E74C3C" opacity="0.9"/>
      
      {/* Progress indicator */}
      <rect x="2" y="20" width="20" height="1" fill={color} opacity="0.3"/>
      <rect x="2" y="20" width="14" height="1" fill={color} opacity="0.9"/>
      
      {/* Enchanted sparkles */}
      <path d="M4 6L5 7L4 8L3 7L4 6Z" fill={color} opacity="0.4"/>
      <path d="M16 4L17 5L16 6L15 5L16 4Z" fill={color} opacity="0.3"/>
    </svg>
  ),

  UploadManuscript: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      {/* Ancient scroll manuscript */}
      <rect x="5" y="4" width="14" height="16" rx="2" fill="#F7F3E9" stroke={color} strokeWidth="1"/>
      <rect x="3" y="4" width="2" height="16" rx="1" fill={color} opacity="0.8"/>
      
      {/* Manuscript text lines */}
      <path d="M8 8L16 8M8 10L16 10M8 12L14 12M8 14L15 14M8 16L13 16" 
            stroke="#2C3A4C" strokeWidth="0.5" opacity="0.6"/>
      
      {/* Mystical upload arrow */}
      <path d="M12 2L12 10M9 5L12 2L15 5" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      
      {/* Decorative illuminated capital */}
      <rect x="7" y="7" width="2" height="2" rx="0.5" fill={color} opacity="0.8"/>
      <circle cx="8" cy="8" r="0.5" fill="#2C3A4C" opacity="0.6"/>
      
      {/* Mystical particles ascending */}
      <circle cx="10" cy="3" r="0.5" fill={color} opacity="0.5"/>
      <circle cx="14" cy="4" r="0.3" fill={color} opacity="0.4"/>
      <circle cx="12" cy="1" r="0.3" fill={color} opacity="0.6"/>
      
      {/* Ornamental corners */}
      <path d="M7 6L8 7L7 8M17 6L16 7L17 8M7 18L8 17L7 16M17 18L16 17L17 16" 
            stroke={color} strokeWidth="0.5" opacity="0.4"/>
    </svg>
  ),

  Analytics: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      {/* Ornate chart columns */}
      <rect x="3" y="16" width="2.5" height="5" rx="0.5" fill={color} fillOpacity="0.7"/>
      <rect x="7" y="13" width="2.5" height="8" rx="0.5" fill={color} fillOpacity="0.8"/>
      <rect x="11" y="10" width="2.5" height="11" rx="0.5" fill={color} fillOpacity="0.9"/>
      <rect x="15" y="7" width="2.5" height="14" rx="0.5" fill={color} fillOpacity="0.9"/>
      <rect x="19" y="5" width="2.5" height="16" rx="0.5" fill={color} fillOpacity="0.8"/>
      
      {/* Mystical trend line */}
      <path d="M4.25 18L8.25 15L12.25 12L17.25 9L20.25 7" 
            stroke={color} strokeWidth="2" fill="none" strokeLinecap="round"/>
      
      {/* Enchanted data points */}
      <circle cx="4.25" cy="18" r="1.5" fill={color} opacity="0.9" stroke="#2C3A4C" strokeWidth="0.5"/>
      <circle cx="8.25" cy="15" r="1.5" fill={color} opacity="0.9" stroke="#2C3A4C" strokeWidth="0.5"/>
      <circle cx="12.25" cy="12" r="1.5" fill={color} opacity="0.9" stroke="#2C3A4C" strokeWidth="0.5"/>
      <circle cx="17.25" cy="9" r="1.5" fill={color} opacity="0.9" stroke="#2C3A4C" strokeWidth="0.5"/>
      <circle cx="20.25" cy="7" r="1.5" fill={color} opacity="0.9" stroke="#2C3A4C" strokeWidth="0.5"/>
      
      {/* Decorative frame */}
      <rect x="2" y="4" width="20" height="17" rx="1" fill="none" stroke={color} strokeWidth="0.5" opacity="0.3"/>
      
      {/* Corner flourishes */}
      <path d="M4 6L5 7L4 8M20 6L19 7L20 8" stroke={color} strokeWidth="0.5" opacity="0.4"/>
    </svg>
  ),

  // ====== STATUS INDICATORS ======
  StatusDraft: ({ size = 16, color = '#4A90E2' }) => (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
      <circle cx="8" cy="8" r="6" fill={color} fillOpacity="0.2" stroke={color} strokeWidth="1"/>
      <path d="M5 8L7 10L11 6" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" opacity="0.7"/>
      <circle cx="8" cy="8" r="3" fill="none" stroke={color} strokeWidth="0.5" opacity="0.3"/>
    </svg>
  ),

  StatusProcessing: ({ size = 16, color = '#F39C12' }) => (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
      <circle cx="8" cy="8" r="6" fill={color} fillOpacity="0.2" stroke={color} strokeWidth="1" opacity="0.3"/>
      <path d="M14 8C14 4.7 11.3 2 8 2" stroke={color} strokeWidth="2" strokeLinecap="round">
        <animateTransform attributeName="transform" attributeType="XML" type="rotate" 
                         from="0 8 8" to="360 8 8" dur="1s" repeatCount="indefinite"/>
      </path>
      <circle cx="8" cy="8" r="2" fill={color} fillOpacity="0.6"/>
    </svg>
  ),

  StatusPublished: ({ size = 16, color = '#27AE60' }) => (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
      <circle cx="8" cy="8" r="6" fill={color} fillOpacity="0.2" stroke={color} strokeWidth="1"/>
      <path d="M5 8L7 10L11 6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="8" cy="8" r="7" fill="none" stroke={color} strokeWidth="0.3" opacity="0.5"/>
      <circle cx="8" cy="8" r="8" fill="none" stroke={color} strokeWidth="0.2" opacity="0.3"/>
    </svg>
  ),

  StatusEarning: ({ size = 16, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
      <circle cx="8" cy="8" r="6" fill={color} fillOpacity="0.8" stroke="#2C3A4C" strokeWidth="0.5"/>
      <circle cx="8" cy="8" r="4" fill="none" stroke="#2C3A4C" strokeWidth="0.5" opacity="0.6"/>
      <path d="M8 5V11M6 7H10M6 9H10" stroke="#2C3A4C" strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="8" cy="8" r="7" fill="none" stroke={color} strokeWidth="0.3" opacity="0.4">
        <animate attributeName="opacity" values="0.4;0.1;0.4" dur="2s" repeatCount="indefinite"/>
      </circle>
    </svg>
  ),

  // ====== INTERFACE CONTROLS ======
  Play: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="1.5" fill="none" opacity="0.6"/>
      <circle cx="12" cy="12" r="8" stroke={color} strokeWidth="0.5" fill="none" opacity="0.3"/>
      <path d="M10 8L18 12L10 16V8Z" fill={color} fillOpacity="0.9"/>
    </svg>
  ),

  Pause: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="1.5" fill="none" opacity="0.6"/>
      <rect x="9" y="8" width="2.5" height="8" rx="0.5" fill={color} fillOpacity="0.9"/>
      <rect x="12.5" y="8" width="2.5" height="8" rx="0.5" fill={color} fillOpacity="0.9"/>
      <path d="M8 8L10 10M16 8L14 10M8 16L10 14M16 16L14 14" stroke={color} strokeWidth="0.5" opacity="0.4"/>
    </svg>
  ),

  Volume: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M11 5L6 9H2V15H6L11 19V5Z" fill={color} fillOpacity="0.8" stroke="#2C3A4C" strokeWidth="0.5"/>
      <path d="M15.54 8.46C16.4 9.36 17 10.61 17 12C17 13.39 16.4 14.64 15.54 15.54" 
            stroke={color} strokeWidth="1.5" strokeLinecap="round" fill="none" opacity="0.7"/>
      <path d="M19.07 4.93C20.9 6.76 22 9.3 22 12C22 14.7 20.9 17.24 19.07 19.07" 
            stroke={color} strokeWidth="1.5" strokeLinecap="round" fill="none" opacity="0.5"/>
      <circle cx="8.5" cy="12" r="0.5" fill="#2C3A4C" opacity="0.6"/>
    </svg>
  ),

  Waveform: ({ size = 20, color = '#D7B377', animated = false }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <g style={animated ? { animation: 'wave-flow 2s ease-in-out infinite' } : {}}>
        <path d="M2 12C4 8 6 16 8 12C10 8 12 16 14 12C16 8 18 16 20 12C22 8 22 16 22 12" 
              stroke={color} strokeWidth="2" fill="none" strokeLinecap="round"/>
        <path d="M2 14C4 18 6 10 8 14C10 18 12 10 14 14C16 18 18 10 20 14" 
              stroke={color} strokeWidth="1" fill="none" opacity="0.5" strokeLinecap="round"/>
      </g>
      <circle cx="6" cy="12" r="1" fill={color} opacity="0.8"/>
      <circle cx="12" cy="12" r="1" fill={color} opacity="0.8"/>
      <circle cx="18" cy="12" r="1" fill={color} opacity="0.8"/>
    </svg>
  ),

  // ====== UTILITY ICONS ======
  Search: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="11" cy="11" r="7" stroke={color} strokeWidth="1.5" fill="none" opacity="0.8"/>
      <circle cx="11" cy="11" r="5" stroke={color} strokeWidth="0.5" fill="none" opacity="0.4"/>
      <path d="M21 21L16.65 16.65" stroke={color} strokeWidth="2" strokeLinecap="round"/>
      <circle cx="11" cy="11" r="2" fill={color} fillOpacity="0.3"/>
      <path d="M8 8L14 14M14 8L8 14" stroke={color} strokeWidth="0.3" opacity="0.3"/>
    </svg>
  ),

  User: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="1" fill="none" opacity="0.3"/>
      <circle cx="12" cy="8" r="3" fill={color} fillOpacity="0.8"/>
      <path d="M6 20C6 16 8.7 14 12 14C15.3 14 18 16 18 20" fill={color} fillOpacity="0.8"/>
      <path d="M9 6C10 5 14 5 15 6" stroke={color} strokeWidth="1" fill="none" opacity="0.5"/>
      <circle cx="10" cy="7" r="0.5" fill={color} opacity="0.6"/>
      <circle cx="14" cy="7" r="0.5" fill={color} opacity="0.6"/>
    </svg>
  ),

  // ====== DECORATIVE ELEMENTS ======
  MagicalSparkle: ({ size = 12, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 12 12" fill="none">
      <path d="M6 1L7 5L11 6L7 7L6 11L5 7L1 6L5 5L6 1Z" fill={color} fillOpacity="0.8"/>
      <circle cx="6" cy="6" r="1" fill={color} fillOpacity="0.9"/>
      <path d="M6 3L6.5 4.5L8 5L6.5 5.5L6 7L5.5 5.5L4 5L5.5 4.5L6 3Z" fill="#2C3A4C" fillOpacity="0.3"/>
    </svg>
  ),

  BookThumbnail: ({ size = 60, color = '#D7B377' }) => (
    <svg width={size} height={Math.round(size * 1.33)} viewBox="0 0 60 80" fill="none">
      <rect x="4" y="4" width="52" height="72" rx="2" fill="#F7F3E9" stroke={color} strokeWidth="1"/>
      <rect x="0" y="4" width="4" height="72" rx="2" fill={color} fillOpacity="0.8"/>
      
      {/* Ornate cover design */}
      <rect x="12" y="12" width="36" height="2" fill={color} fillOpacity="0.8"/>
      <rect x="16" y="18" width="28" height="1" fill={color} fillOpacity="0.6"/>
      <rect x="16" y="22" width="28" height="1" fill={color} fillOpacity="0.6"/>
      <rect x="16" y="26" width="20" height="1" fill={color} fillOpacity="0.6"/>
      
      {/* Decorative elements */}
      <circle cx="2" cy="16" r="1" fill="#2C3A4C" fillOpacity="0.4"/>
      <circle cx="2" cy="32" r="1" fill="#2C3A4C" fillOpacity="0.4"/>
      <circle cx="2" cy="48" r="1" fill="#2C3A4C" fillOpacity="0.4"/>
      <circle cx="2" cy="64" r="1" fill="#2C3A4C" fillOpacity="0.4"/>
      
      {/* Mystical corner flourishes */}
      <path d="M8 8L10 10L8 12M48 8L46 10L48 12M8 68L10 66L8 64M48 68L46 66L48 64" 
            stroke={color} strokeWidth="0.5" opacity="0.5"/>
    </svg>
  ),

  // ====== ARROW AND NAVIGATION ======
  ArrowLeft: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M19 12H5M12 19L5 12L12 5" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="0.5" fill="none" opacity="0.2"/>
    </svg>
  ),

  ArrowRight: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M5 12H19M12 5L19 12L12 19" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="0.5" fill="none" opacity="0.2"/>
    </svg>
  ),

  ArrowUp: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M12 19V5M5 12L12 5L19 12" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="0.5" fill="none" opacity="0.2"/>
    </svg>
  ),

  Download: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M21 15V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V15" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7 10L12 15L17 10" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="12" y1="15" x2="12" y2="3" stroke={color} strokeWidth="2" strokeLinecap="round"/>
      <circle cx="12" cy="8" r="6" stroke={color} strokeWidth="0.3" fill="none" opacity="0.3"/>
    </svg>
  ),

  Plus: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="1.5" fill="none" opacity="0.6"/>
      <path d="M12 8V16M8 12H16" stroke={color} strokeWidth="2" strokeLinecap="round"/>
      <circle cx="12" cy="12" r="6" stroke={color} strokeWidth="0.5" fill="none" opacity="0.3"/>
    </svg>
  ),

  X: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="1" fill="none" opacity="0.3"/>
      <path d="M15 9L9 15M9 9L15 15" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),

  Warning: ({ size = 20, color = '#F39C12' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M12 2L22 20H2L12 2Z" stroke={color} strokeWidth="1.5" fill={color} fillOpacity="0.1"/>
      <circle cx="12" cy="8" r="1" fill={color}/>
      <line x1="12" y1="12" x2="12" y2="16" stroke={color} strokeWidth="2" strokeLinecap="round"/>
      <path d="M6 18L9 15M18 18L15 15" stroke={color} strokeWidth="0.5" opacity="0.5"/>
    </svg>
  ),

  Zap: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      {/* Lightning bolt with mystical elements */}
      <path d="M13 2L4.09 12.97L9 13L7 22L15.91 11.03L11 11L13 2Z" 
            fill={color} fillOpacity="0.8" stroke="#2C3A4C" strokeWidth="0.5"/>
      {/* Inner spark */}
      <path d="M11.5 6L8.5 11H10.5L9.5 16L12.5 11H10.5L11.5 6Z" 
            fill="#F7F3E9" fillOpacity="0.6"/>
      {/* Decorative energy dots */}
      <circle cx="6" cy="8" r="0.5" fill={color} fillOpacity="0.4"/>
      <circle cx="18" cy="14" r="0.5" fill={color} fillOpacity="0.4"/>
      <circle cx="5" cy="16" r="0.3" fill={color} fillOpacity="0.3"/>
      <circle cx="19" cy="7" r="0.3" fill={color} fillOpacity="0.3"/>
    </svg>
  ),

  // Custom Book Loading Animation - Stylized page turning effect (from user's TSX)
  BookLoading: ({ size = 80, color = '#D7B377', sparkleColor = '#F7F3E9' }) => (
    <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
      <svg width={size} height={size} viewBox="0 0 80 80" fill="none">
        {/* Book shadow/base */}
        <ellipse cx="40" cy="65" rx="35" ry="8" fill={color} fillOpacity="0.1"/>

        {/* Left page - perspective view (STATIC) */}
        <path
          d="M40 20 Q25 18 10 22 L10 55 Q25 59 40 58 Z"
          fill="#F7F3E9"
          stroke={color}
          strokeWidth="1.5"
        />

        {/* Right page - perspective view (STATIC) */}
        <path
          d="M40 20 Q55 18 70 22 L70 55 Q55 59 40 58 Z"
          fill="#F7F3E9"
          stroke={color}
          strokeWidth="1.5"
        />

        {/* Center spine/binding (STATIC) */}
        <path
          d="M40 18 L40 60"
          stroke={color}
          strokeWidth="3"
          strokeLinecap="round"
        />

        {/* Book binding curve at top (STATIC) */}
        <path
          d="M10 22 Q25 18 40 20 Q55 18 70 22"
          stroke={color}
          strokeWidth="2"
          fill="none"
        />

        {/* Book binding curve at bottom (STATIC) */}
        <path
          d="M10 55 Q25 59 40 58 Q55 59 70 55"
          stroke={color}
          strokeWidth="2"
          fill="none"
        />

        {/* Text lines on left page (STATIC) */}
        <g opacity="0.4">
          <path d="M15 30 L35 29" stroke={color} strokeWidth="0.8"/>
          <path d="M15 35 L33 34" stroke={color} strokeWidth="0.8"/>
          <path d="M15 40 L35 39" stroke={color} strokeWidth="0.8"/>
          <path d="M15 45 L30 44" stroke={color} strokeWidth="0.8"/>
        </g>

        {/* Text lines on right page (STATIC) */}
        <g opacity="0.4">
          <path d="M45 29 L65 30" stroke={color} strokeWidth="0.8"/>
          <path d="M47 34 L65 35" stroke={color} strokeWidth="0.8"/>
          <path d="M45 39 L65 40" stroke={color} strokeWidth="0.8"/>
          <path d="M50 44 L65 45" stroke={color} strokeWidth="0.8"/>
        </g>

        {/* Animated flipping pages (ONLY THESE ANIMATE) */}
        <g className="flipping-pages">
          {[0, 1, 2].map((index) => (
            <g key={index} opacity="0" style={{
              animation: `vox-page-flip 3.6s ease-in-out ${index * 1.2}s infinite`,
              transformOrigin: '40px 39px'
            }}>
              {/* Page attached to spine */}
              <path
                d="M40 20 Q55 18 70 22 L70 55 Q55 59 40 58 Z"
                fill="#F7F3E9"
                stroke={color}
                strokeWidth="1"
                opacity="0.9"
                style={{
                  transformOrigin: '40px 39px',
                  animation: `vox-page-turn 3.6s ease-in-out ${index * 1.2}s infinite`
                }}
              />
              {/* Shadow that follows the page */}
              <path
                d="M40 20 L40 58"
                stroke={color}
                strokeWidth="8"
                opacity="0.1"
                style={{
                  transformOrigin: '40px 39px',
                  animation: `vox-shadow-follow 3.6s ease-in-out ${index * 1.2}s infinite`
                }}
              />
              {/* Page text that disappears as it flips */}
              <g opacity="0.4" style={{
                animation: `vox-text-fade 3.6s ease-in-out ${index * 1.2}s infinite`
              }}>
                <path d="M45 29 L65 30" stroke={color} strokeWidth="0.5"/>
                <path d="M47 35 L63 36" stroke={color} strokeWidth="0.5"/>
                <path d="M45 41 L65 42" stroke={color} strokeWidth="0.5"/>
                <path d="M50 47 L60 48" stroke={color} strokeWidth="0.5"/>
              </g>
            </g>
          ))}
        </g>

        {/* Magical sparkles (FLOAT UP AND DOWN) */}
        <g className="sparkles">
          {/* Top center sparkle */}
          <g style={{ animation: 'vox-sparkle-float 4s ease-in-out infinite' }}>
            <path
              d="M40 10 L42 14 L46 12 L42 14 L40 18 L38 14 L34 12 L38 14 L40 10Z"
              fill={sparkleColor}
              opacity="0.8"
            />
            <circle cx="40" cy="14" r="1" fill={color} opacity="0.6"/>
          </g>

          {/* Side sparkles */}
          <g style={{ animation: 'vox-sparkle-float 4s ease-in-out 0.7s infinite' }}>
            <path
              d="M20 12 L21 14 L23 13 L21 14 L20 16 L19 14 L17 13 L19 14 L20 12Z"
              fill={sparkleColor}
              opacity="0.6"
              transform="scale(0.7)"
            />
          </g>

          <g style={{ animation: 'vox-sparkle-float 4s ease-in-out 1.4s infinite' }}>
            <path
              d="M60 12 L61 14 L63 13 L61 14 L60 16 L59 14 L57 13 L59 14 L60 12Z"
              fill={sparkleColor}
              opacity="0.6"
              transform="scale(0.7)"
            />
          </g>

          {/* Floating particles */}
          <circle cx="25" cy="40" r="1" fill={sparkleColor} opacity="0.4"
            style={{ animation: 'vox-particle-rise 4s ease-in-out infinite' }}/>
          <circle cx="55" cy="45" r="1" fill={sparkleColor} opacity="0.4"
            style={{ animation: 'vox-particle-rise 4s ease-in-out 1s infinite' }}/>
          <circle cx="40" cy="42" r="0.5" fill={sparkleColor} opacity="0.6"
            style={{ animation: 'vox-particle-rise 4s ease-in-out 2s infinite' }}/>
        </g>

        {/* Decorative elements (STATIC) */}
        <circle cx="40" cy="39" r="3" fill="none" stroke={color} strokeWidth="0.5" opacity="0.3"/>
        <circle cx="40" cy="39" r="1.5" fill={color} fillOpacity="0.2"/>
      </svg>

      <style>
        {`
          @keyframes vox-page-flip {
            0%, 100% {
              opacity: 0;
            }
            10%, 90% {
              opacity: 1;
            }
          }

          @keyframes vox-page-turn {
            0% {
              transform: rotateY(0deg) scaleX(1);
            }
            50% {
              transform: rotateY(-80deg) scaleX(0.2);
            }
            100% {
              transform: rotateY(-180deg) scaleX(1);
            }
          }

          @keyframes vox-shadow-follow {
            0%, 100% {
              transform: scaleX(0) translateX(0);
              opacity: 0;
            }
            20% {
              transform: scaleX(1) translateX(5px);
              opacity: 0.1;
            }
            50% {
              transform: scaleX(2) translateX(15px);
              opacity: 0.15;
            }
            80% {
              transform: scaleX(1) translateX(5px);
              opacity: 0.1;
            }
          }

          @keyframes vox-text-fade {
            0%, 20% {
              opacity: 0.4;
            }
            40%, 100% {
              opacity: 0;
            }
          }

          @keyframes vox-sparkle-float {
            0%, 100% {
              transform: translateY(0) scale(1);
              opacity: 0.8;
            }
            50% {
              transform: translateY(-3px) scale(1.1);
              opacity: 1;
            }
          }

          @keyframes vox-particle-rise {
            0% {
              transform: translateY(0) translateX(0);
              opacity: 0;
            }
            20% {
              opacity: 0.6;
            }
            80% {
              opacity: 0.6;
            }
            100% {
              transform: translateY(-20px) translateX(2px);
              opacity: 0;
            }
          }
        `}
      </style>
    </div>
  ),

  // Standard loading spinner (fallback)
  Loading: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className="vox-loading-spin">
      <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="2" strokeOpacity="0.3"/>
      <path d="M12 3C16.97 3 21 7.03 21 12" stroke={color} strokeWidth="2" strokeLinecap="round">
        <animateTransform attributeName="transform" attributeType="XML" type="rotate" 
                         from="0 12 12" to="360 12 12" dur="1s" repeatCount="indefinite"/>
      </path>
      <circle cx="12" cy="12" r="2" fill={color} fillOpacity="0.6"/>
    </svg>
  ),

  Check: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M9 12L11 14L15 10" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="1.5" fill="none" opacity="0.6"/>
    </svg>
  ),

  AlertCircle: ({ size = 20, color = '#EF4444' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2"/>
      <path d="M12 8v4" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 16h.01" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),

  // ====== PAYMENT RELATED ICONS ======
  Card: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      {/* Credit card body */}
      <rect x="3" y="6" width="18" height="12" rx="3" fill={color} fillOpacity="0.1" stroke={color} strokeWidth="1.5"/>
      {/* Card stripe */}
      <rect x="3" y="9" width="18" height="2" fill={color} fillOpacity="0.7"/>
      {/* Card chip */}
      <rect x="6" y="12" width="2" height="1.5" rx="0.3" fill={color}/>
      {/* Card numbers indication */}
      <circle cx="12" cy="14" r="0.5" fill={color} fillOpacity="0.5"/>
      <circle cx="14" cy="14" r="0.5" fill={color} fillOpacity="0.5"/>
      <circle cx="16" cy="14" r="0.5" fill={color} fillOpacity="0.5"/>
      <circle cx="18" cy="14" r="0.5" fill={color} fillOpacity="0.5"/>
      {/* Security features */}
      <path d="M5 7L7 5M19 7L17 5" stroke={color} strokeWidth="0.5" opacity="0.4"/>
    </svg>
  ),

  Wallet: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      {/* Wallet body */}
      <rect x="3" y="7" width="18" height="12" rx="2" fill={color} fillOpacity="0.1" stroke={color} strokeWidth="1.5"/>
      {/* Wallet fold */}
      <path d="M3 7L21 7L19 5L5 5Z" fill={color} fillOpacity="0.3" stroke={color} strokeWidth="1"/>
      {/* Card slots */}
      <rect x="5" y="9" width="8" height="1" fill={color} fillOpacity="0.4"/>
      <rect x="5" y="11" width="6" height="1" fill={color} fillOpacity="0.3"/>
      <rect x="5" y="13" width="7" height="1" fill={color} fillOpacity="0.4"/>
      {/* Money bills */}
      <rect x="15" y="10" width="4" height="2" fill={color} fillOpacity="0.6" stroke={color} strokeWidth="0.5"/>
      <rect x="15.5" y="12.5" width="4" height="2" fill={color} fillOpacity="0.4" stroke={color} strokeWidth="0.5"/>
      {/* Closure */}
      <circle cx="19" cy="15" r="1" fill={color} fillOpacity="0.7"/>
    </svg>
  ),

  Shield: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      {/* Shield outline with mystical styling */}
      <path d="M12 2L20 6V12C20 16.5 16.5 20 12 22C7.5 20 4 16.5 4 12V6L12 2Z" 
            fill={color} fillOpacity="0.1" stroke={color} strokeWidth="1.5"/>
      {/* Inner protection symbol */}
      <circle cx="12" cy="12" r="4" stroke={color} strokeWidth="1" opacity="0.7" fill="none"/>
      <path d="M10 12L11.5 13.5L14 10.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      {/* Decorative corners */}
      <path d="M8 8L9 7M16 8L15 7M8 16L9 17M16 16L15 17" stroke={color} strokeWidth="0.5" opacity="0.5"/>
      {/* Mystical emanation */}
      <circle cx="12" cy="12" r="6" stroke={color} strokeWidth="0.3" opacity="0.3"/>
    </svg>
  ),

  // Missing icons needed by PlayerCharacterVoiceManager
  Sparkles: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M12 3L13 10L12 11L11 10L12 3Z" fill={color}/>
      <path d="M21 12L14 13L13 12L14 11L21 12Z" fill={color}/>
      <path d="M12 21L11 14L12 13L13 14L12 21Z" fill={color}/>
      <path d="M3 12L10 11L11 12L10 13L3 12Z" fill={color}/>
      <circle cx="12" cy="12" r="1.5" fill={color}/>
    </svg>
  ),

  Hand: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M13 5.5a1.5 1.5 0 0 1 3 0V10h1.5a1.5 1.5 0 0 1 0 3H17v3.5a5.5 5.5 0 1 1-11 0V12a1 1 0 0 1 1-1h1.5V9.5a1.5 1.5 0 0 1 3 0v1.5H13V5.5z" stroke={color} strokeWidth="1.5" fill="none"/>
    </svg>
  ),

  Info: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="1.5" fill="none"/>
      <path d="M12 16V12M12 8H12.01" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),

  BookOpen: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" fill="none" stroke={color} strokeWidth="1.5"/>
      <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" fill="none" stroke={color} strokeWidth="1.5"/>
    </svg>
  ),

  Refresh: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M21.5 2v6h-6" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M2.5 22v-6h6" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M19.13 5.09A10 10 0 0 0 8.5 2.5L15.5 8" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4.87 18.91A10 10 0 0 0 15.5 21.5L8.5 16" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),

  Warning: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M12 2L2 22h20L12 2z" stroke={color} strokeWidth="1.5" fill="none"/>
      <path d="M12 9v4" stroke={color} strokeWidth="2" strokeLinecap="round"/>
      <path d="M12 17h.01" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),

  Star: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" 
            fill={color} fillOpacity="0.8" stroke="#2C3A4C" strokeWidth="0.5"/>
      <circle cx="12" cy="12" r="8" stroke={color} strokeWidth="0.3" fill="none" opacity="0.2"/>
      <path d="M12 6L13.5 10.5L18 12L13.5 13.5L12 18L10.5 13.5L6 12L10.5 10.5L12 6Z" 
            fill="#2C3A4C" fillOpacity="0.3"/>
    </svg>
  ),

  // Missing Player Icons
  SkipBack: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M19 20L9 12L19 4V20Z" fill={color} fillOpacity="0.8"/>
      <path d="M5 19V5" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),

  SkipForward: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M5 4L15 12L5 20V4Z" fill={color} fillOpacity="0.8"/>
      <path d="M19 5V19" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),

  Speed: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2Z" 
            stroke={color} strokeWidth="1.5" fill="none"/>
      <path d="M12 6V12L16 14" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="12" cy="12" r="2" fill={color} fillOpacity="0.6"/>
      <path d="M8 8L16 16M16 8L8 16" stroke={color} strokeWidth="0.5" opacity="0.3"/>
    </svg>
  ),

  List: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M8 6H21M8 12H21M8 18H21" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="4" cy="6" r="1" fill={color}/>
      <circle cx="4" cy="12" r="1" fill={color}/>
      <circle cx="4" cy="18" r="1" fill={color}/>
    </svg>
  ),

  // Missing Voice Manager Icons
  VoiceStudio: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M12 2C13.1 2 14 2.9 14 4V12C14 13.1 13.1 14 12 14C10.9 14 10 13.1 10 12V4C10 2.9 10.9 2 12 2Z" stroke={color} strokeWidth="1.5" fill="none"/>
      <path d="M5 10V12C5 15.866 8.134 19 12 19C15.866 19 19 15.866 19 12V10" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M12 19V22M12 22H8M12 22H16" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="12" cy="8" r="0.5" fill={color}/>
      <circle cx="12" cy="6" r="0.5" fill={color}/>
    </svg>
  ),

  Settings: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" stroke={color} strokeWidth="1.5"/>
      <circle cx="12" cy="12" r="3" stroke={color} strokeWidth="1.5"/>
    </svg>
  ),

  MagicalSparkle: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M12 3L13.5 8.5L12 9L10.5 8.5L12 3Z" fill={color}/>
      <path d="M19 10L13.5 10.5L13 10L13.5 9.5L19 10Z" fill={color}/>
      <path d="M12 17L10.5 11.5L12 11L13.5 11.5L12 17Z" fill={color}/>
      <path d="M5 10L10.5 9.5L11 10L10.5 10.5L5 10Z" fill={color}/>
      <circle cx="12" cy="10" r="1" fill={color} opacity="0.8"/>
      <path d="M18 6L19 7L18 8L17 7L18 6Z" fill={color} opacity="0.6"/>
      <path d="M6 16L7 17L6 18L5 17L6 16Z" fill={color} opacity="0.6"/>
    </svg>
  ),

  // ====== LOGOUT ICON ======
  Logout: ({ size = 20, color = '#E74C3C' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      {/* Door frame */}
      <rect x="3" y="3" width="12" height="18" rx="2" fill="none" stroke={color} strokeWidth="1.5" opacity="0.6"/>
      {/* Exit arrow */}
      <path d="M16 12H8M16 12L13 9M16 12L13 15" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      {/* Door handle */}
      <circle cx="11" cy="12" r="1" fill={color} opacity="0.8"/>
      {/* Exit indicator */}
      <path d="M20 9V15" stroke={color} strokeWidth="2" strokeLinecap="round" opacity="0.7"/>
    </svg>
  ),

  Chart: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M3 3v18h18" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9 9l5 5 6-6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),

  FileText: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <polyline points="14,2 14,8 20,8" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="16" y1="13" x2="8" y2="13" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="16" y1="17" x2="8" y2="17" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <polyline points="10,9 9,9 8,9" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),

  Person: ({ size = 20, color = '#D7B377' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="12" cy="7" r="4" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),

  Crown: ({ size = 24, color = '#D7B377', ...props }) => (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke={color} 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      {...props}
    >
      <path d="M12 6L8 12l4 6 4-6-4-6z"/>
      <path d="M12 6L8 2l-2 4 6 0z"/>
      <path d="M12 6L16 2l2 4-6 0z"/>
      <path d="M8 12L4 8l-2 4 6 0z"/>
      <path d="M16 12L20 8l2 4-6 0z"/>
    </svg>
  ),

  Clock: ({ size = 24, color = '#D7B377', ...props }) => (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke={color} 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      {...props}
    >
      <circle cx="12" cy="12" r="10"></circle>
      <polyline points="12,6 12,12 16,14"></polyline>
    </svg>
  ),

  RotateCcw: ({ size = 24, color = '#D7B377', ...props }) => (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke={color} 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      {...props}
    >
      <polyline points="1,4 1,10 7,10"></polyline>
      <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>
    </svg>
  ),

  TrendingUp: ({ size = 24, color = '#D7B377', ...props }) => (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke={color} 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      {...props}
    >
      <polyline points="23,6 13.5,15.5 8.5,10.5 1,18"></polyline>
      <polyline points="17,6 23,6 23,12"></polyline>
    </svg>
  ),

  TrendingDown: ({ size = 24, color = '#D7B377', ...props }) => (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke={color} 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      {...props}
    >
      <polyline points="23,18 13.5,8.5 8.5,13.5 1,6"></polyline>
      <polyline points="17,18 23,18 23,12"></polyline>
    </svg>
  ),

  BarChart: ({ size = 24, color = '#D7B377', ...props }) => (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke={color} 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      {...props}
    >
      <line x1="12" y1="20" x2="12" y2="10"></line>
      <line x1="18" y1="20" x2="18" y2="4"></line>
      <line x1="6" y1="20" x2="6" y2="16"></line>
    </svg>
  ),

  Lightbulb: ({ size = 24, color = '#D7B377', ...props }) => (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke={color} 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      {...props}
    >
      <path d="M9 21h6"></path>
      <path d="M12 17v-6a5 5 0 1 0-10 0v6l2 2h6l2-2z"></path>
    </svg>
  ),

  PieChart: ({ size = 24, color = '#D7B377', ...props }) => (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke={color} 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      {...props}
    >
      <path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path>
      <path d="M22 12A10 10 0 0 0 12 2v10z"></path>
    </svg>
  ),

  Target: ({ size = 24, color = '#D7B377', ...props }) => (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke={color} 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      {...props}
    >
      <circle cx="12" cy="12" r="10"></circle>
      <circle cx="12" cy="12" r="6"></circle>
      <circle cx="12" cy="12" r="2"></circle>
    </svg>
  ),

  Trophy: ({ size = 24, color = '#D7B377', ...props }) => (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke={color} 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      {...props}
    >
      <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"></path>
      <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"></path>
      <path d="M4 22h16"></path>
      <path d="M10 14.66V17c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-2.34"></path>
      <rect x="7" y="9" width="10" height="8" rx="1"></rect>
    </svg>
  ),

  Heart: ({ size = 24, color = '#D7B377', ...props }) => (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke={color} 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      {...props}
    >
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
    </svg>
  ),

  Tool: ({ size = 24, color = '#D7B377', ...props }) => (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke={color} 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      {...props}
    >
      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
    </svg>
  ),

  Activity: ({ size = 24, color = '#D7B377', ...props }) => (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke={color} 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      {...props}
    >
      <polyline points="22,12 18,12 15,21 9,3 6,12 2,12"></polyline>
    </svg>
  ),

  Database: ({ size = 24, color = '#D7B377', ...props }) => (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke={color} 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      {...props}
    >
      <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
      <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"></path>
      <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"></path>
    </svg>
  ),

  DollarSign: ({ size = 24, color = '#D7B377', ...props }) => (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke={color} 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      {...props}
    >
      <line x1="12" y1="1" x2="12" y2="23"></line>
      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
    </svg>
  )
};

// Move AlertTriangle and Users inside the main object
VoxSmythIcons.AlertTriangle = ({ size = 20, color = '#D7B377' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <line x1="12" y1="9" x2="12" y2="13" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="12" cy="17" r="1" fill={color} />
  </svg>
);

VoxSmythIcons.Users = ({ size = 20, color = '#D7B377' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="8.5" cy="7" r="4" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M20 8v6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M23 11h-6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// Enhanced Animation Keyframes with Literary Magic
export const VoxSmythAnimations = `
  @keyframes sound-pulse {
    0%, 100% { 
      opacity: 0.4; 
      transform: scaleX(1); 
    }
    50% { 
      opacity: 0.8; 
      transform: scaleX(1.1); 
    }
  }
  
  @keyframes wave-flow {
    0%, 100% { 
      transform: translateX(0); 
    }
    50% { 
      transform: translateX(2px); 
    }
  }
  
  @keyframes ink-drop {
    0%, 100% { 
      transform: scale(1) translateY(0); 
      opacity: 0.5; 
    }
    50% { 
      transform: scale(1.2) translateY(-1px); 
      opacity: 0.9; 
    }
  }
  
  @keyframes mystical-glow {
    0%, 100% { 
      filter: drop-shadow(0 0 3px rgba(215, 179, 119, 0.3)); 
    }
    50% { 
      filter: drop-shadow(0 0 8px rgba(215, 179, 119, 0.6)); 
    }
  }
  
  @keyframes floating-sparkle {
    0%, 100% { 
      transform: translateY(0) rotate(0deg); 
      opacity: 0.6; 
    }
    50% { 
      transform: translateY(-2px) rotate(180deg); 
      opacity: 1; 
    }
  }
  
  @keyframes parchment-glow {
    0%, 100% { 
      box-shadow: 0 0 0 rgba(215, 179, 119, 0); 
    }
    50% { 
      box-shadow: 0 0 12px rgba(215, 179, 119, 0.3); 
    }
  }
  
  @keyframes quill-write {
    0% { 
      stroke-dashoffset: 20; 
    }
    100% { 
      stroke-dashoffset: 0; 
    }
  }
  
  @keyframes brass-shimmer {
    0%, 100% { 
      opacity: 0.6; 
    }
    50% { 
      opacity: 0.9; 
    }
  }
`;

// Usage Examples and Color Variants
export const VoxSmythColorPalette = {
  primary: '#2C3A4C',      // Deep Slate
  accent: '#D7B377',       // Antique Brass
  parchment: '#F7F3E9',    // Warm Parchment
  lightParchment: '#F9F6F0', // Light Parchment
  deepSlate: '#1A202C',    // Deep Slate
  success: '#27AE60',      // Mystical Green
  warning: '#F39C12',      // Brass Warning
  error: '#E74C3C',        // Ink Red
  info: '#4A90E2'          // Scroll Blue
};

// Add missing icons for Creator Studio functionality
VoxSmythIcons.Robot = ({ size = 20, color = '#D7B377' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <rect x="6" y="6" width="12" height="10" rx="2" stroke={color} strokeWidth="1.5" fill="none"/>
    <circle cx="9" cy="10" r="1" fill={color}/>
    <circle cx="15" cy="10" r="1" fill={color}/>
    <path d="M10 13h4" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M12 2v4M8 2h8M4 8v8M20 8v8M6 18v2h2M16 18v2h2" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

VoxSmythIcons.Trash = ({ size = 20, color = '#E74C3C' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <polyline points="3,6 5,6 21,6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="10" y1="11" x2="10" y2="17" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <line x1="14" y1="11" x2="14" y2="17" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);


VoxSmythIcons.Upload = ({ size = 20, color = '#D7B377' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <polyline points="7,10 12,5 17,10" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="12" y1="5" x2="12" y2="15" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

VoxSmythIcons.AudioBook = ({ size = 20, color = '#D7B377' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <rect x="4" y="4" width="13" height="16" rx="2" stroke={color} strokeWidth="1.5" fill="none"/>
    <path d="M8 8h5M8 12h5M8 16h3" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="18" cy="16" r="3" stroke={color} strokeWidth="1.5" fill="none"/>
    <path d="M16 14v4l2-1" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

VoxSmythIcons.StatusBoard = ({ size = 20, color = '#D7B377' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <rect x="3" y="3" width="18" height="14" rx="2" stroke={color} strokeWidth="1.5" fill="none"/>
    <path d="M7 8h3M7 12h5M7 16h2M13 8h4M13 12h4M13 16h4" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M3 7h18M8 17v4M16 17v4M6 21h12" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

VoxSmythIcons.Users = ({ size = 20, color = '#D7B377' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="9" cy="7" r="4" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

VoxSmythIcons.UserPlus = ({ size = 20, color = '#D7B377' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="8.5" cy="7" r="4" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="20" y1="8" x2="20" y2="14" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="23" y1="11" x2="17" y2="11" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

VoxSmythIcons.Microphone = ({ size = 20, color = '#D7B377' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" fill={color} fillOpacity="0.7"/>
    <path d="M19 10v2a7 7 0 0 1-14 0v-2" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="12" y1="19" x2="12" y2="23" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="8" y1="23" x2="16" y2="23" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

VoxSmythIcons.Tag = ({ size = 20, color = '#D7B377' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="7" y1="7" x2="7.01" y2="7" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

VoxSmythIcons.Book = ({ size = 20, color = '#D7B377' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

VoxSmythIcons.AlertTriangle = ({ size = 20, color = '#D7B377' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 9v4" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 17h.01" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

VoxSmythIcons.ThumbsUp = ({ size = 20, color = '#D7B377' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

VoxSmythIcons.ThumbsDown = ({ size = 20, color = '#D7B377' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Add missing icons for FloatingFeedbackButton
VoxSmythIcons.MessageCircle = ({ size = 20, color = '#D7B377' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

VoxSmythIcons.Star = ({ size = 20, color = '#D7B377', fill = 'none' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={fill}>
    <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

VoxSmythIcons.Check = ({ size = 20, color = '#D7B377' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <polyline points="20,6 9,17 4,12" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

VoxSmythIcons.X = ({ size = 20, color = '#D7B377' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <line x1="18" y1="6" x2="6" y2="18" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="6" y1="6" x2="18" y2="18" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

VoxSmythIcons.Analytics = ({ size = 20, color = '#D7B377' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M8 21V3M16 21V11M4 21V14M12 21V7M20 21V14" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="8" cy="8" r="1" fill={color} opacity="0.8"/>
    <circle cx="12" cy="12" r="1" fill={color} opacity="0.8"/>
    <circle cx="16" cy="16" r="1" fill={color} opacity="0.8"/>
    <circle cx="20" cy="18" r="1" fill={color} opacity="0.8"/>
    <circle cx="4" cy="18" r="1" fill={color} opacity="0.8"/>
  </svg>
);

VoxSmythIcons.RefreshCw = ({ size = 20, color = '#D7B377' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M3 12A9 9 0 019 3a9.75 9.75 0 016.74 2.74L21 3v4h-4l1.26-1.26A9.75 9.75 0 019 12a9 9 0 11-6-8.49" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M21 12a9 9 0 01-9 9c-2.49 0-4.74-1.01-6.37-2.64L3 21v-4h4l-1.26 1.26A9.75 9.75 0 0012 21a9 9 0 009-9" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" opacity="0.6"/>
    <circle cx="12" cy="12" r="1" fill={color} opacity="0.8"/>
  </svg>
);

VoxSmythIcons.Music = ({ size = 20, color = '#D7B377' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M9 18V5l12-2v13" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="6" cy="18" r="3" stroke={color} strokeWidth="2" fill="none"/>
    <circle cx="18" cy="16" r="3" stroke={color} strokeWidth="2" fill="none"/>
  </svg>
);

VoxSmythIcons.AlertTriangle = ({ size = 20, color = '#E67E22' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="12" y1="9" x2="12" y2="13" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <line x1="12" y1="17" x2="12.01" y2="17" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

// Add export of the new icons
export default VoxSmythIcons;